export default "__VITE_ASSET__pe0NNDug__"